import { reaction } from "mobx";
export var tick = function (msMin, msMax) {
    var duration = msMin && msMax ? Math.random() * (msMax - msMin) + msMin : msMin;
    return new Promise(function (resolve) { return setTimeout(resolve, duration); });
};
export default tick;
export var doEvery = function (fn, interval, options) {
    var ref = setInterval(function () {
        if ((options === null || options === void 0 ? void 0 : options.while) && !options.while()) {
            cleanup();
            return;
        }
        fn();
    }, interval);
    if (options === null || options === void 0 ? void 0 : options.fireImmediately)
        fn();
    var disposer;
    if (options === null || options === void 0 ? void 0 : options.until) {
        disposer = reaction(options.until, function (value) { return value && cleanup(); });
    }
    var cleanup = function () {
        clearInterval(ref);
        disposer === null || disposer === void 0 ? void 0 : disposer();
    };
    return cleanup;
};
